import { ImgHTMLAttributes } from 'react'
import styled from '@emotion/styled'
import { noop } from 'lodash-es'

import FakeImage from '../../../Common/FakeImage'

const EditOverlay = styled.div`
  position: absolute;

  bottom: 0;
  left: 0;

  width: 100%;
  height: 100%;

  color: white;
  border-radius: 100%;

  padding: 0.25em 0.5em;
  background: rgba(0, 0, 0, 0.6);
  display: none;

  align-items: center;
  justify-content: center;
  user-select: none;
  font-size: 1rem;
`

const AvatarWrapper = styled.div<Partial<IAvatarProps>>`
  width: ${props => props.width || '3.5rem'};
  height: ${props => props.height || '3.5rem'};
  font-size: ${props => props.fontSize || '2rem'};
  position: relative;
  display: inline-block;
  margin-right: 0.5rem;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 100%;
  ${props =>
    props.editable &&
    `
    &:hover ${EditOverlay} {
      display: flex;
      cursor: pointer;
    }`}
`

const Image = styled.img`
  width: 100%;
  height: 100%;
`

interface IAvatarProps extends ImgHTMLAttributes<HTMLImageElement> {
  name: string
  editable?: boolean
  width?: string
  height?: string
  fontSize?: string
}

const AvatarComponent = ({
  name,
  src = '',
  editable = false,
  onClick,
  ...props
}: IAvatarProps) => {
  const badImage = !src || src.includes('dummyimage')

  const imageToRender = badImage ? (
    <FakeImage title={name} />
  ) : (
    <Image draggable={false} alt={name} src={src} />
  )

  return (
    <AvatarWrapper
      editable={editable}
      onClick={onClick ?? noop}
      {...props}
      width={props.width}
      height={props.height}
      fontSize={props.fontSize}
    >
      {imageToRender}
      {editable && (
        <EditOverlay>
          <span>Edit</span>
        </EditOverlay>
      )}
    </AvatarWrapper>
  )
}

export default AvatarComponent
